import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, withStyles } from "@material-ui/core";
import CancelAcceptForm from "../../Common/CancelAcceptForm";
import AssignedCarsList from "../../Common/AssignedCarsList";
import t from "../../../languages/pl";
import UserEditableFields from '../AddUser/UserEditableFields';
import ConfirmationDialog from "../../Common/ConfirmationDialog";
import AssignCarsDialog from '../../Common/AssignCarsDialog';
import ChangePasswordExpirationDialog from '../../Common/ChangePasswordExpirationDialog';
import { mapUserEditDto } from '../../../requests/mapApiObject';
import { isEmail } from "../../../utils/helpers";

const useStyles = theme => ({
  row: {
    margin: theme.spacing(1),
    display: "flex",
    justifyContent: "flex-start",
  }
});

const UserDetailsDialog = props => {
  const {
    classes,
    open,
    onClose,
    data,
    cars,
    onDelete,
    onPasswordReset,
    onExpirationChange,
    onSubmit,
    onCarsAssign
  } = props;
  const [confOpen, setConfOpen] = useState(false);
  const [passwordResetConfOpen, setPasswordResetConfOpen] = useState(false);
  const [assignOpen, setAssignOpen] = useState(false);
  const [passwordExpirationOpen, setPasswordExpirationOpen] = useState(false);
  const [userTyp, setUserTyp] = useState(data.uzytkownik_typ);
  const formRef = useRef();

  const handleCarsAssign = carIds => {
    onCarsAssign && onCarsAssign(data.uzytkownik_id, carIds);
    setAssignOpen(false);
  };

  const handleExpirationChange = (value) => {
    onExpirationChange(data.uzytkownik_id, value);
    setPasswordExpirationOpen(false);
  };

  const validateUserData = data => {
    if (!isEmail(data.email))
      return false;
    return data.name.length >= 1;
  };

  const handleSubmit = (values) => {
    if (validateUserData(values)) {
      onSubmit && onSubmit(mapUserEditDto(values), data.uzytkownik_id);
      onClose();
    }
  };

  const handleOnTypeChange = (type) => {
    setUserTyp(type);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>
        {t.manageUser}
      </DialogTitle>
      <DialogContent>

        <UserEditableFields
          ref={formRef}
          email={data.uzytkownik_email}
          username={data.uzytkownik_login}
          name={data.uzytkownik_nazwa}
          typ={data.uzytkownik_typ}
          pracuje_od={data.pracuje_od}
          pracuje_do={data.pracuje_do}
          onTypeChange={handleOnTypeChange}
          onSubmit={handleSubmit}
        />

        <AssignedCarsList data={cars}/>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          disabled={userTyp === 'podadmin'}
          onClick={() => setAssignOpen(true)}
        >
          {t.assignCars}
        </Button>
        <ButtonGroup
          variant="contained"
          color="primary"
        >
          <Button
            onClick={() => setPasswordExpirationOpen(true)}
          >
            {t.changePasswordExpiration}
          </Button>
          <Button
            onClick={() => setPasswordResetConfOpen(true)}
          >
            {t.resetPassword}
          </Button>
        </ButtonGroup>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setConfOpen(true)}
        >
          {t.deleteUser}
        </Button>
        <CancelAcceptForm
          onCancel={onClose}
          onSubmit={() => formRef.current.dispatchEvent(new Event("submit"))}
        />
      </DialogActions>
      <ConfirmationDialog
        open={confOpen}
        onClose={() => setConfOpen(false)}
        action={t.deleteThisUser}
        id={data.uzytkownik_id}
        onSubmit={(id) => onDelete(id)}
      />
      <ConfirmationDialog
        open={passwordResetConfOpen}
        onClose={() => setPasswordResetConfOpen(false)}
        action={t.changePasswordForThisUser}
        id={data.uzytkownik_id}
        onSubmit={(id) => onPasswordReset(id)}
      />
      <ChangePasswordExpirationDialog
        open={passwordExpirationOpen}
        onClose={() => setPasswordExpirationOpen(false)}
        onSubmit={handleExpirationChange}
      />
      {
        assignOpen
        &&
        <AssignCarsDialog
          open={assignOpen}
          onClose={() => setAssignOpen(false)}
          carsInGroup={cars}
          onSubmit={handleCarsAssign}
          title={t.toUser + " " + data.uzytkownik_login}
        />
      }
    </Dialog>
  );
};

UserDetailsDialog.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  data: PropTypes.object,
  cars: PropTypes.array,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  onPasswordReset: PropTypes.func,
  onSubmit: PropTypes.func,
  onExpirationChange: PropTypes.func,
  onCarsAssign: PropTypes.func
};

UserDetailsDialog.defaultProps = {
  cars: []
};

export default withStyles(useStyles)(UserDetailsDialog);
